import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';

export const Route = createFileRoute('/(client)/transactions/(pages)/(create)')(
  {
    beforeLoad: async () => {
      const perms = await ensurePermissions();
      if (!perms['fiber-forward'].canCreate) {
        throw redirect({ to: '/transactions/incoming' });
      }
    },
  },
);
